<template>
  <div>
    <page-header>
      <div class="row">
        <div class="col-xs-12 text-center">
          <img class="_margin-bottom-20" src="../../assets/results-page/ashp.png"
            style="width: 100%; max-width: 500px" />

          <h1 class="text-center center-block _margin-bottom-30" style="max-width: 700px; margin: auto">
            Discover Heat Pump
          </h1>

          <uiv-btn type="primary" @click="onExplore">Explore Heat Pump</uiv-btn>
        </div>
      </div>
    </page-header>

    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <p style="max-width: none">
            Switching to a heat pump can cut your heating costs and reduce
            reliance on fossil fuels dependent on how you currently heat your
            home. We provide a view of how switching to a heat pump can benefit
            your home, both financially and environmentally.
          </p>
        </div>
      </div>
    </div>

    <div class="page-section">
      <div class="container">
        <div class="row">
          <div class="col-md-5">
            <img src="../../assets/home/person-3.png" />
            <div class="_margin-bottom-20 visible-xs visible-sm"></div>
          </div>

          <div class="col-md-7">
            <h4>What You'll Discover</h4>
            <ul>
              <li>Carbon Footprint Reduction</li>
              <li>Annual Electricity Costs for Your Heat Pump</li>
              <li>Recommended Heat Pump Size</li>
              <li>Best Energy Tariff for Your Heat Pump</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="container _margin-top-10">
      <div class="row">
        <div class="col-md-8">
          <h4 class="_margin-bottom-0">
            Get Started with Your Heat Pump Journey
          </h4>
          <p class="_margin-top-0">
            Enter your postcode and see how much you could save by switching
            from gas, oil, or electric heating to an Air-Source Heat Pump.
          </p>
        </div>

        <div class="col-md-4">
          <img class="_margin-bottom-20" src="../../assets/home/polar-bear.png" />
          <uiv-btn type="primary" block @click="onExplore">Explore Heat Pump</uiv-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import YourHome from '@/components/current-tariff/YourHome';
import PageHeader from '@/components/page-header/PageHeader';

import { mapState } from 'vuex';

export default {
  name: 'HeatPump',
  mounted() {
    this.$store.dispatch('tracing/addAction', {
      name: 'Action',
      value: 'Viewed'
    });
    this.$store.dispatch('tracing/saveActions');
  },
  computed: {
    ...mapState({
      quote: ({ session }) => session.quote_journey_session
    })
  },
  methods: {
    onExplore() {
      this.quote.evCompare = false;
      this.quote.evOnly = false;
      this.quote.ashp = true;
      this.quote.solar = false;
      this.$store.dispatch('session/setItem', {
        key: 'quote_journey_session',
        value: this.quote
      });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Explore Heat Pump' });
      this.$store.dispatch('tracing/saveActions');
      this.$router.push({ name: 'currentTariff' });
    }
  },
  components: {
    YourHome,
    PageHeader
  }
};
</script>

<style lang="scss" scoped>
.page-section {
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: rgba(0, 76, 146, 0.2);

  ul {
    padding-left: 0;
    list-style: none;

    li {
      padding: 10px;
      background-color: #fff;
      margin-bottom: 10px;
      font-size: 20px;
      border-radius: 17px;
    }
  }
}
</style>
